var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1780395370607,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 5822,
    width: 32,
    height: 32,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M227.555556 910.222222v-56.888889h568.888888v56.888889H227.555556zM56.888889 56.888889h910.222222v739.555555H56.888889V56.888889z m56.888889 56.888889v625.777778h796.444444V113.777778H113.777778z",
    fill: "#014590",
    "p-id": 5823
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M335.644444 455.111111H796.444444V398.222222H335.644444l91.022223-91.022222-39.822223-39.822222L227.555556 426.666667l159.288888 159.288889 39.822223-39.822223z",
    fill: "#014590",
    "p-id": 5824
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackold);
export default __webpack_public_path__ + "static/media/backold.fb400f0a8276f640be73d2ba95b60552.svg";
export { ForwardRef as ReactComponent };